import { useChat } from '../../contexts/ChatContext';

interface AskAIButtonProps {
  variant: 'nav' | 'inline';
}

const SparkleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
  </svg>
);

const AskAIButton = ({ variant }: AskAIButtonProps) => {
  const { toggleChat } = useChat();

  if (variant === 'nav') {
    return (
      <button
        type="button"
        onClick={toggleChat}
        className="px-3 py-2 text-base font-medium rounded-lg transition-all duration-200 inline-flex items-center gap-1.5 hover:bg-gradient-to-r hover:from-purple-500 hover:to-indigo-500 hover:text-white"
        style={{ color: 'var(--text-secondary)' }}
      >
        <SparkleIcon />
        Ask AI
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggleChat}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-purple-500 to-indigo-500 hover:from-purple-600 hover:to-indigo-600 transition-all duration-200 shadow-md hover:shadow-lg"
    >
      <SparkleIcon />
      Ask AI about Alexander
    </button>
  );
};

export default AskAIButton;
